import 'react-phone-input-2/lib/style.css'
import PhoneInput from 'react-phone-input-2'
import clsx from 'clsx'
import { forwardRef } from 'react'

interface PhoneNumberInputProps {
    label?: string
    value: string
    onChange: (value: string) => void
    error?: string
    helpText?: string
    className?: string
}

const PhoneNumberInput = ({
    label,
    value,
    onChange,
    error,
    helpText,
    className,
}: PhoneNumberInputProps) => {
    return (
        <div className="form-group input--lg w-full">
            {label && (
                <div className="form-group-label">
                    <label className="label">{label}</label>
                </div>
            )}

            <PhoneInput
                country="us"
                value={value}
                onChange={onChange}
            />

            {helpText && !error && (
                <label className="form-label">
                    <div className="text--xs color-secondary-light">
                        <span>{helpText}</span>
                    </div>
                </label>
            )}
            {error && (
                <label className="form-label">
                    <div
                        className="label--text"
                        style={{ color: 'var(--danger)' }}
                    >
                        <span>{error}</span>
                    </div>
                </label>
            )}
        </div>
    )
}

export default PhoneNumberInput
